import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export function getPickersToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiPickersToolbar', slot);
}
export const pickersToolbarClasses = generateUtilityClasses('MuiPickersToolbar', ['root', 'title', 'content']);